import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { SiteBuildingState } from './site-building.state';

const ON = 'bg-gray-900 text-white dark:bg-slate-100 dark:text-slate-900';
const OFF =
  'border border-gray-200 text-gray-700 hover:bg-gray-100 dark:border-slate-600 dark:text-slate-200 dark:hover:bg-slate-700';

/**
 * Choix du plan (contours GeoJSON ou modèle 3D) puis, en modèle 3D, étage, toit et vue 2D / 3D
 * (ADR-017). Rien tant que le site n'a pas de modèle. Fiche tracker et rejeu des positions.
 */
@Component({
  selector: 'lib-site-building-controls',
  standalone: true,
  imports: [TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (building().model(); as model) {
      <div
        class="mb-2 flex flex-wrap items-center gap-1.5"
        role="group"
        [attr.aria-label]="'siteViewMap.building.plan' | transloco">
        <span class="mr-0.5 text-xs font-semibold text-gray-500 dark:text-slate-400">{{
          'siteViewMap.building.plan' | transloco
        }}</span>
        @for (v of [false, true]; track v) {
          <button
            type="button"
            class="h-7 rounded px-2.5 text-xs font-bold"
            [class]="building().shown() === v ? on : off"
            [attr.aria-pressed]="building().shown() === v"
            (click)="building().show(v)">
            {{ (v ? 'siteViewMap.building.model' : 'siteViewMap.building.outlines') | transloco }}
          </button>
        }
      </div>
      @if (building().shown()) {
        <div class="flex flex-wrap items-center gap-1.5">
          @for (l of model.levels; track l.id) {
            <button
              type="button"
              class="h-7 rounded px-2.5 text-xs font-bold"
              [class]="building().floor() === l.id ? on : off"
              [attr.aria-pressed]="building().floor() === l.id"
              (click)="building().setFloor(l.id)">
              {{ l.name }}
            </button>
          }
          <button
            type="button"
            class="h-7 rounded px-2.5 text-xs font-bold"
            [class]="building().floor() === 'all' ? on : off"
            [attr.aria-pressed]="building().floor() === 'all'"
            (click)="building().setFloor('all')">
            {{ 'siteViewMap.building.roof' | transloco }}
          </button>
          <span class="mx-0.5 h-5 w-px bg-gray-200 dark:bg-slate-600"></span>
          @for (v of [false, true]; track v) {
            <button
              type="button"
              class="h-7 rounded px-2.5 text-xs font-bold"
              [class]="building().is3d() === v ? on : off"
              [attr.aria-pressed]="building().is3d() === v"
              (click)="building().set3d(v)">
              {{ v ? '3D' : '2D' }}
            </button>
          }
        </div>
      }
    }
  `,
})
export class SiteBuildingControlsComponent {
  readonly building = input.required<SiteBuildingState>();
  protected readonly on = ON;
  protected readonly off = OFF;
}
